export default __webpack_public_path__ + "static/media/testimonials@2x.9753dfc0.png";